import { Question, QuestionUserType } from '../../../../hooks/api/questions';
import { IQuestionStatistic } from '../../../../hooks/api/questionStatistic';

export const filterQuestionsByUserType = (questions: Question[], userType: QuestionUserType) => questions
  .filter((q) => q.userType === 'all' || q.userType === userType)
  .map(({ createdAt, updatedAt, ...question }): Question => question)
  .sort((a, b) => a.order - b.order);

export function filterStatisticByUserType(
  list: IQuestionStatistic['list'],
  userType: QuestionUserType,
): IQuestionStatistic['list'] {
  return list
    .map(({ legend, data }) => {
      const filteredData = data.filter((item) => {
        if (userType === 'all') {
          return item.userType === 'all' || !item.userType; /** if userType is missing - return 'all' type */
        }

        return item.userType === userType;
      });

      return {
        legend,
        data: filteredData,
      };
    })
    .filter(({ data }) => data.length > 0); // remove groups without data
}
